/** Реквизиты оператора ПДн. Источник: ЕГРИП / оферта diobuch.ru. */

export const OPERATOR_NAME =
  'Индивидуальный предприниматель Власенко Борис Анатольевич';
export const OPERATOR_INN = '772100754584';
export const OPERATOR_OGRNIP = '317774600300552';
export const OPERATOR_EMAIL = 'boris-vlasenko@yandex.ru';
export const OPERATOR_PHONE = '+7 (962) 405-97-24';
export const OPERATOR_REGION = 'г. Москва';
export const OFERTA_PATH = '/oferta';
export const CONTACT_TELEGRAM = 'https://t.me/borisvlasenko';
export const CONTACT_VK = 'https://vk.com/boris_vlasenko';
export const POLICY_DATE = '18 августа 2026 г.';
export const SITES_LABEL = 'new.diobuch.ru и diobuch.ru';
